module.exports = __webpack_public_path__ + "h5/img/support.16d75577.png";